import { api } from "../api";
import { toastSuccess, toastError } from "../ui/messages";
import { refreshModal } from "../ui/modal";
import { getDomElement, setHtml, fadeIn, setText } from "../utils/dom";
import { config } from "../config";
import { SERVER_BASE_URL } from "../lib/server";

export async function regenintall(): Promise<void> {
  try {
    await api.mockups.regenAll();
    toastSuccess("You can now generate a new download");
    refreshModal();
  } catch (err: unknown) {
    toastError((err as Error).message);
  }
}

export async function dlallinteriors(): Promise<void> {
  try {
    await api.mockups.downloadAll();
    toastSuccess("Creating download package...");
    refreshModal();
  } catch (err: unknown) {
    toastError((err as Error).message);
  }
}

export async function ptDlDo(id: string): Promise<void> {
  if (parseInt(id) > 0) {
    try {
      // Trigger the file download directly via iframe — /ptdlfile handles
      // both inventory registration and serving the file
      setHtml(
        "frametarget",
        `<iframe src="${SERVER_BASE_URL}/ptdlfile?id=${encodeURIComponent(id)}"></iframe>`
      );

      toastSuccess("Download started");
      setHtml(
        `view-download-buttons-${id}`,
        '<span style="font-size: 0.7em; font-weight: 400;"><i>Artwork downloaded</i></span>'
      );

      if (!config.isAdmin) {
        fadeIn("quick-downloader");
      }

      const qdlcount = parseInt(getDomElement("quick-downloader-count")?.innerHTML ?? "0") + 1;
      setText("quick-downloader-count", String(qdlcount));

      if (qdlcount === 1) {
        setText("quick-downloader-s", "");
      } else {
        setText("quick-downloader-s", "s");
      }
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : "Download failed";
      toastError(msg);
    }
  } else {
    toastError("Not a valid Artwork ID");
  }
}

export async function dlDo(id: string): Promise<void> {
  if (parseInt(id) > 0) {
    try {
      const response = await api.downloadCart.dlDo({ id: parseInt(id) });
      toastSuccess("Download started");
      setHtml("frametarget", `<iframe src="${response.url}"></iframe>`);
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : "Download failed";
      toastError(msg);
    }
  } else {
    toastError("Not a valid Artwork ID");
  }
}

export async function savedlsettings(): Promise<void> {
  const interiors = getDomElement<HTMLInputElement>("dl_interiors")?.checked ?? false;
  const res = getDomElement<HTMLInputElement>("dl_res_2")?.checked ? 2 : 1;

  try {
    await api.reseller.setDlSettings({ interiors, res });
  } catch (err: unknown) {
    toastError((err as Error).message);
  }
}
